import _ from 'underscore';

export default function fillRoute(route, {
  CampaignId,
  AdGroupId,
}) {
  let filled = route;

  if (!_.isNull(CampaignId)) {
    filled = filled.replace(':campaign_id', CampaignId);
  }
  if (!_.isNull(AdGroupId)) {
    filled = filled.replace(':adgroup_id', AdGroupId);
  }

  return filled;
}
